import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative w-full bg-black border-t border-gray-900">
      <div className="w-[90%] max-w-[1400px] mx-auto py-12 sm:py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-12 mb-12 lg:mb-16">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-5">
            <div className="mb-6 lg:mb-10">
              <img
                src="https://public.readdy.ai/ai/img_res/d6ebd2a1-416d-4d41-8f5c-6f36fe395e24.png"
                alt="Motion Boyz"
                className="w-32 sm:w-44 h-auto"
                style={{ filter: 'drop-shadow(0 0 20px rgba(0, 212, 255, 0.4))' }}
              />
            </div>
            <h3 className="text-white text-xl sm:text-2xl md:text-3xl font-light mb-4 sm:mb-8">Motion Never Stops</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Motion Boyz represents the energy of the streets, the ambition of the hustlers, and the power of never stopping. We create luxury streetwear for those who move with purpose and style.
            </p>
          </div>

          {/* Shop */}
          <div className="lg:col-span-3">
            <h4 className="text-gray-500 text-xs tracking-widest uppercase mb-5 lg:mb-8">Shop</h4>
            <nav className="space-y-4 lg:space-y-6">
              {['New Arrivals', 'Hoodies', 'Denim Sets', 'Accessories', 'All Products'].map((item) => (
                <a key={item} href="#collection" className="block text-white text-sm sm:text-base font-light hover:text-[#00d4ff] transition-colors duration-300 cursor-pointer group">
                  <span className="border-b border-transparent group-hover:border-[#00d4ff] transition-all duration-300">{item}</span>
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <h4 className="text-gray-500 text-xs tracking-widest uppercase mb-5 lg:mb-8">Contact</h4>
            <div className="mb-8">
              <a href="mailto:llc.motionboyz@gmail.com" className="text-white text-sm sm:text-base border-b border-white/30 hover:border-[#00d4ff] hover:text-[#00d4ff] transition-all duration-300 cursor-pointer break-all">
                llc.motionboyz@gmail.com
              </a>
            </div>
            <h4 className="text-gray-500 text-xs tracking-widest uppercase mb-4 sm:mb-6">Follow The Motion</h4>
            <div className="flex gap-3 flex-wrap">
              {[
                { href: 'https://www.instagram.com/motionboyzwear/', icon: 'ri-instagram-line', label: 'Instagram' },
                { href: 'https://www.tiktok.com/@motion.boyz82', icon: 'ri-tiktok-line', label: 'TikTok' },
                { href: 'https://x.com/MotionBoyzwear', icon: 'ri-twitter-x-line', label: 'X (Twitter)' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-700 text-white hover:text-[#00d4ff] hover:border-[#00d4ff] hover:shadow-[0_0_12px_rgba(0,212,255,0.4)] transition-all duration-300 cursor-pointer"
                  title={s.label}
                >
                  <i className={`${s.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 sm:pt-8 border-t border-gray-900 flex flex-col sm:flex-row justify-between items-center gap-4 text-center sm:text-left">
          <div className="flex gap-6">
            <Link to="/terms" className="text-gray-500 text-xs hover:text-white transition-colors duration-300 border-b border-gray-800 hover:border-white cursor-pointer whitespace-nowrap">
              Terms
            </Link>
            <Link to="/privacy" className="text-gray-500 text-xs hover:text-white transition-colors duration-300 border-b border-gray-800 hover:border-white cursor-pointer whitespace-nowrap">
              Privacy
            </Link>
            <Link to="/cookies" className="text-gray-500 text-xs hover:text-white transition-colors duration-300 border-b border-gray-800 hover:border-white cursor-pointer whitespace-nowrap">
              Cookies
            </Link>
            <Link to="/refund" className="text-gray-500 text-xs hover:text-white transition-colors duration-300 border-b border-gray-800 hover:border-white cursor-pointer whitespace-nowrap">
              Returns
            </Link>
          </div>
          <p className="text-gray-500 text-xs">© 2026 Motion Boyz. All rights reserved.</p>
          <p className="text-gray-500 text-xs">
            Designed with <span className="text-[#00d4ff]" style={{ textShadow: '0 0 10px rgba(0, 212, 255, 0.5)' }}>Motion</span>
          </p>
        </div>
      </div>
    </footer>
  );
}